
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import {Question, Serializer, SurveyModel, surveyLocalization} from "survey-core";
import { PropertyGridEditorCollection } from 'survey-creator-core';

@Component
export default class QuestionGeneratorModal extends Vue {
  count = 1;

  openModal(): void {
    this.count = 1;
    $(this.$refs.modal).modal('show');
  }

  closeModal(): void {
    $(this.$refs.modal).modal('hide');
  }

  okClicked(): void {
    this.$emit('ok', this.count);
    this.closeModal();
  }
}

export function registerQuestionGeneratorModalProperties(): void {
   
  Serializer.addProperty('survey', {
  name: 'makequestions',
  category: 'general',
  type: 'string',
  displayName: {
    default: 'Make questions',
    de: 'Fragen erstellen',
    en: 'Make questions',
    hu: 'Kérdések készítése',
    sl: 'Ustvari vprašanja',
    hr: 'Izradi pitanja',
  } as any,
  visibleIndex: 9,
  default: '',
});

PropertyGridEditorCollection.register({
  fit: (prop) => prop.name === 'makequestions',
  getJSON: () => {
    const buttonText = surveyLocalization.getString("makequestions") || "Fragen erzeugen";
    return {
      type: 'html',
      html: `<button type="button" class="btn btn-primary btn-sm" data-action="make-questions">${buttonText}</button>`,
    };
  },
});

}

